/**
 * 充值记录 API
 */

import client from './client';

export interface Purchase {
  id: number;
  device_id: string;
  transaction_id: string;
  product_id: string;
  product_type: string;
  purchase_date: string;
  expiration_date: string | null;
  quantity: number;
  price: string | null;
  currency: string | null;
  created_at: string;
}

export interface PurchaseListResponse {
  success: boolean;
  data: {
    purchases: Purchase[];
    pagination: {
      page: number;
      page_size: number;
      total: number;
    };
    stats: {
      total_purchases: number;
      total_subscriptions: number;
      total_consumables: number;
    };
  };
}

export interface PurchaseListParams {
  page?: number;
  page_size?: number;
  product_type?: string;
  product_id?: string;
  search?: string;
  start_date?: string;
  end_date?: string;
}

/**
 * 获取充值记录列表
 */
export const listPurchases = async (params?: PurchaseListParams): Promise<PurchaseListResponse> => {
  const response = await client.get('/admin/purchases', { params });
  return response.data;
};
